import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
  import CourseApi from '@/services/api/CourseApi'
  import QuestionWithButtons from '@/components/common/QuestionWithButtons.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import { useRoute, useRouter } from 'vue-router/composables'
  import type { Question } from '@/services/interfaces/QuizQuestion'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LessonQuizQuestion',
  setup(__props) {

  const router = useRouter()
  const route = useRoute()
  const question = ref<Question | null>(null)
  const questionId = route.params.questionId
  const inResultsMode = ref(false)

  CourseApi.getQuestion(questionId).then((data) => {
    question.value = data
  })

  const toLesson = () => {
    router.push({ name: 'Lesson' }).catch(() => {
      return
    })
  }

return { __sfc: true,router, route, question, questionId, inResultsMode, toLesson, ref, CourseApi, QuestionWithButtons, KetchUpButton, LoadingSpinner, useRoute, useRouter }
}

})